import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
export function Guarantee() {
  return <Section tone="white" data-id="element-175" data-mp="24n85qg2t0cwr">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-cta/25 bg-[#f2fbf5] p-6 text-center sm:p-9" data-id="element-176" data-mp="24mydsmy77vof">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-cta" data-id="element-177" data-mp="29eyiesp7rcrc">
          <ShieldCheckIcon className="h-8 w-8 text-white" aria-hidden="true" data-id="element-178" data-mp="2ebyhukrk5h9h" />
        </span>
        <p className="mt-4 text-[11px] font-extrabold uppercase tracking-[0.18em] text-cta" data-id="element-179" data-mp="2jb1lc0rw3ffc">
          7-day guarantee
        </p>
        <h2 className="mt-2 font-display text-[26px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-180" data-mp="2obz166pffxdo">
          Explore it. Use it. Decide for yourself.
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-181" data-mp="txy1jjm1z6cj">
          You’ll have 7 days to access Renal Decision Desk™, review the decision
          pathways, and determine whether the system provides the practical
          structure you’re looking for.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-182" data-mp="3nuzt9nzbhb8c">
          If you decide it isn’t right for you, simply contact us within the
          guarantee period and we’ll refund your purchase according to the
          applicable refund policy.
        </p>
        <p className="mt-4 text-[14px] font-bold text-ink" data-id="element-183" data-mp="3duphm7sxkbva">
          No long-term commitment. No recurring payment.
        </p>
      </div>

      <TransformCTA label="Yes — I want to try Renal Decision Desk™" sub="Get instant access for $27 • Protected by our 7-day guarantee" data-id="element-184" data-mp="afk1h58pwtl4" />
    </Section>;
}